
import { mapMutations } from 'vuex'
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'
export default {
    name: 'Taiwan',
    components: { BlogTextColor },
}
